module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5"
  }, [_c('div', {
    staticClass: "row pt-5"
  }, [_c('div', {
    staticClass: "col-sm-2 d-flex align-items-center"
  }, [_c('avatar-uploader', {
    attrs: {
      "value": _vm.localCompany.imageLogo,
      "originalImage": _vm.localCompanyOriginal.imageLogo || _vm.localCompanyOriginal.imageLogoBase64,
      "placeholder": 'agent',
      "showLabel": false,
      "showPreview": true,
      "requirementsBelowImage": true,
      "showRequirements": false,
      "showButton": false,
      "isSizeOk": _vm.avatarRequirements.isSizeOk,
      "isFormatOk": _vm.avatarRequirements.isFormatOk,
      "image": _vm.localCompany.imageLogo,
      "imageBase64": _vm.localCompany.imageLogoBase64,
      "imageHash": _vm.localCompany.imageLogoHash,
      "originalImageSync": _vm.localCompanyOriginal.imageLogo,
      "originalImageBase64Sync": _vm.localCompanyOriginal.imageLogoBase64,
      "originalHashSync": _vm.localCompanyOriginal.imageLogoHash
    },
    on: {
      "update:isSizeOk": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isSizeOk", $event)
      },
      "update:is-size-ok": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isSizeOk", $event)
      },
      "update:isFormatOk": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isFormatOk", $event)
      },
      "update:is-format-ok": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isFormatOk", $event)
      },
      "update:image": function($event) {
        return _vm.$set(_vm.localCompany, "imageLogo", $event)
      },
      "update:imageBase64": function($event) {
        return _vm.$set(_vm.localCompany, "imageLogoBase64", $event)
      },
      "update:image-base64": function($event) {
        return _vm.$set(_vm.localCompany, "imageLogoBase64", $event)
      },
      "update:imageHash": function($event) {
        return _vm.$set(_vm.localCompany, "imageLogoHash", $event)
      },
      "update:image-hash": function($event) {
        return _vm.$set(_vm.localCompany, "imageLogoHash", $event)
      },
      "update:originalImageSync": function($event) {
        return _vm.$set(_vm.localCompanyOriginal, "imageLogo", $event)
      },
      "update:original-image-sync": function($event) {
        return _vm.$set(_vm.localCompanyOriginal, "imageLogo", $event)
      },
      "update:originalImageBase64Sync": function($event) {
        return _vm.$set(_vm.localCompanyOriginal, "imageLogoBase64", $event)
      },
      "update:original-image-base64-sync": function($event) {
        return _vm.$set(_vm.localCompanyOriginal, "imageLogoBase64", $event)
      },
      "update:originalHashSync": function($event) {
        return _vm.$set(_vm.localCompanyOriginal, "imageLogoHash", $event)
      },
      "update:original-hash-sync": function($event) {
        return _vm.$set(_vm.localCompanyOriginal, "imageLogoHash", $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 mt-n2"
  }, [_c('div', {
    staticClass: "col-sm-6 d-flex align-items-end"
  }, [_c('div', [_c('label', {
    staticClass: "full mt-1"
  }, [_vm._v("\n                        Company Brand Name\n                        "), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.brand),
      expression: "localCompany.brand"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localCompany.brand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "brand", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.localCompany.brand.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.localCompany.brand.required) ? _c('span', [_vm._v("Brand Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.localCompany.brand.minLength) ? _c('span', [_vm._v("Must have at least 4 characters")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('avatar-uploader', {
    staticClass: "mt-3",
    attrs: {
      "value": _vm.localCompany.imageLogo,
      "originalImage": _vm.localCompanyOriginal.imageLogo || _vm.localCompanyOriginal.imageLogoBase64,
      "placeholder": 'agent',
      "showLabel": false,
      "showPreview": false,
      "showRequirements": true,
      "showButton": true,
      "buttonType": 'logo',
      "isSizeOk": _vm.avatarRequirements.isSizeOk,
      "isFormatOk": _vm.avatarRequirements.isFormatOk,
      "image": _vm.localCompany.imageLogo,
      "imageBase64": _vm.localCompany.imageLogoBase64,
      "imageHash": _vm.localCompany.imageLogoHash,
      "originalImageSync": _vm.localCompanyOriginal.imageLogo,
      "originalImageBase64Sync": _vm.localCompanyOriginal.imageLogoBase64,
      "originalHashSync": _vm.localCompanyOriginal.imageLogoHash
    },
    on: {
      "update:isSizeOk": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isSizeOk", $event)
      },
      "update:is-size-ok": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isSizeOk", $event)
      },
      "update:isFormatOk": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isFormatOk", $event)
      },
      "update:is-format-ok": function($event) {
        return _vm.$set(_vm.avatarRequirements, "isFormatOk", $event)
      },
      "update:image": function($event) {
        return _vm.$set(_vm.localCompany, "imageLogo", $event)
      },
      "update:imageBase64": function($event) {
        return _vm.$set(_vm.localCompany, "imageLogoBase64", $event)
      },
      "update:image-base64": function($event) {
        return _vm.$set(_vm.localCompany, "imageLogoBase64", $event)
      },
      "update:imageHash": function($event) {
        return _vm.$set(_vm.localCompany, "imageLogoHash", $event)
      },
      "update:image-hash": function($event) {
        return _vm.$set(_vm.localCompany, "imageLogoHash", $event)
      },
      "update:originalImageSync": function($event) {
        return _vm.$set(_vm.localCompanyOriginal, "imageLogo", $event)
      },
      "update:original-image-sync": function($event) {
        return _vm.$set(_vm.localCompanyOriginal, "imageLogo", $event)
      },
      "update:originalImageBase64Sync": function($event) {
        return _vm.$set(_vm.localCompanyOriginal, "imageLogoBase64", $event)
      },
      "update:original-image-base64-sync": function($event) {
        return _vm.$set(_vm.localCompanyOriginal, "imageLogoBase64", $event)
      },
      "update:originalHashSync": function($event) {
        return _vm.$set(_vm.localCompanyOriginal, "imageLogoHash", $event)
      },
      "update:original-hash-sync": function($event) {
        return _vm.$set(_vm.localCompanyOriginal, "imageLogoHash", $event)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 mb-2 mt-n3 text-right"
  }, [_c('input', {
    staticClass: "btn green widest",
    class: {
      tertiary: _vm.$v.localCompany.$invalid
    },
    attrs: {
      "type": "submit",
      "value": "Save",
      "disabled": !_vm.isDirty
    },
    on: {
      "click": _vm.save
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('div', {
    staticClass: "border-bottom-medium font-weight-600 darker pb-1 mb-3"
  }, [_vm._v("\n                    Company Details\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Legal Company Name\n                                "), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.companyName),
      expression: "localCompany.companyName"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localCompany.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "companyName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.localCompany.companyName.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.localCompany.companyName.required) ? _c('span', [_vm._v("Company Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.localCompany.companyName.minLength) ? _c('span', [_vm._v("Must have at least 4 characters.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Website\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.website),
      expression: "localCompany.website"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localCompany.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "website", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.localCompany.website.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.localCompany.website.invalid) ? _c('span', [_vm._v("Must be a valid website.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 p-0"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                            Company Address\n                            "), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.companyAddress),
      expression: "localCompany.companyAddress"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.localCompany.companyAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "companyAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.localCompany.companyAddress.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.localCompany.companyAddress.required) ? _c('span', [_vm._v("Company Address is required.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                ZIP-Code\n                                "), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.postalCode),
      expression: "localCompany.postalCode"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localCompany.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "postalCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.localCompany.postalCode.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.localCompany.postalCode.required) ? _c('span', [_vm._v("ZIP-Code is required.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Location\n                                "), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.location),
      expression: "localCompany.location"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localCompany.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "location", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.localCompany.location.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.localCompany.location.required) ? _c('span', [_vm._v("Location is required.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_vm._m(0), _vm._v(" "), _c('country-picker', {
    attrs: {
      "openDirection": 'bottom',
      "selectedCountryValue": _vm.selectedCountry,
      "disabled": false,
      "allowEmpty": false
    },
    on: {
      "input": function($event) {
        return _vm.updateCountry($event)
      }
    }
  }), _vm._v(" "), (_vm.$v.localCompany.country.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.localCompany.country.required) ? _c('span', [_vm._v("Country is required.")]) : _vm._e()]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                License Number\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.licenseNumber),
      expression: "localCompany.licenseNumber"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localCompany.licenseNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "licenseNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                CAE\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.cae),
      expression: "localCompany.cae"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localCompany.cae)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "cae", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                VAT Number\n                                "), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.registrationNumber),
      expression: "localCompany.registrationNumber"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localCompany.registrationNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "registrationNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.localCompany.registrationNumber.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.localCompany.registrationNumber.required) ? _c('span', [_vm._v("VAT Number is required.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Registry office\n                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.registryOffice),
      expression: "localCompany.registryOffice"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localCompany.registryOffice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "registryOffice", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v(" Time Zone ")]), _vm._v(" "), (_vm.getTimezones) ? _c('v-select', {
    attrs: {
      "options": _vm.timeZonesList,
      "label": "value"
    },
    on: {
      "input": _vm.timeZoneChanged
    },
    model: {
      value: (_vm.selectedTimezone),
      callback: function($$v) {
        _vm.selectedTimezone = $$v
      },
      expression: "selectedTimezone"
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "border-bottom-medium font-weight-600 darker pb-1 mb-3"
  }, [_vm._v("Bio")]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Company Bio\n                                "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.biography),
      expression: "localCompany.biography"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "rows": "4",
      "placeholder": "Write a small biography describing your company."
    },
    domProps: {
      "value": (_vm.localCompany.biography)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "biography", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "border-bottom-medium font-weight-600 darker pb-1 mb-3"
  }, [_vm._v("\n                    Contacts\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-8 py-0 mb-2",
    class: {
      error: _vm.$v.localCompany.reservationEmail.$invalid
    }
  }, [_c('label', {
    staticClass: "full",
    class: {
      error: _vm.$v.localCompany.reservationEmail.$invalid
    }
  }, [_c('span', [_vm._v("Email - Reservations ")]), _c('span', {
    staticClass: "brand"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "normal fs-smaller"
  }, [_vm._v("(you can enter multiple emails by separating them with\n                                    comma \",\")")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.reservationEmail),
      expression: "localCompany.reservationEmail"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text",
      "placeholder": "email1@domain.com, email2@domain.com, email3@domain.com"
    },
    domProps: {
      "value": (_vm.localCompany.reservationEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "reservationEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.localCompany.reservationEmail.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(_vm.localCompany.reservationEmail && !_vm.$v.localCompany.reservationEmail.isEmailValid) ? _c('span', [_vm._v("\n                                    Must be a valid email.\n                                ")]) : _vm._e(), _vm._v(" "), (!_vm.$v.localCompany.reservationEmail.required) ? _c('span', [_vm._v("\n                                    Email - Reservations is required.\n                                ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Phone - Reservations\n                                "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.reservationPhone),
      expression: "localCompany.reservationPhone"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localCompany.reservationPhone)
    },
    on: {
      "blur": function($event) {
        return _vm.onPhoneBlur($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "reservationPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.localCompany.reservationPhone.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.localCompany.reservationPhone.required) ? _c('span', [_vm._v("Phone - Reservations is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.localCompany.reservationPhone.numeric) ? _c('span', [_vm._v("Must be a valid phone.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-8 py-0 mb-2",
    class: {
      error: _vm.$v.localCompany.financialEmail.$invalid
    }
  }, [_c('label', {
    staticClass: "full",
    class: {
      error: _vm.$v.localCompany.financialEmail.$invalid
    }
  }, [_c('span', [_vm._v("Email - Financial")]), _vm._v(" "), _c('span', {
    staticClass: "normal fs-smaller"
  }, [_vm._v("(you can enter multiple emails by separating them with\n                                    comma \",\")")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.financialEmail),
      expression: "localCompany.financialEmail"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text",
      "placeholder": "email1@domain.com, email2@domain.com, email3@domain.com"
    },
    domProps: {
      "value": (_vm.localCompany.financialEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "financialEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.localCompany.financialEmail.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.localCompany.financialEmail.isEmailValid) ? _c('span', [_vm._v("Must be a valid email. ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "border-bottom-medium font-weight-600 darker pb-1 mb-3"
  }, [_vm._v("\n                    Calendar\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-4 py-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v(" Start Hour ")]), _vm._v(" "), _c('timepicker', {
    staticClass: "mt-2",
    attrs: {
      "format": "hh:mm",
      "showOnTop": true,
      "availableHours": _vm.possibleCalendarHours,
      "defaultTime": _vm.defaultCalendarStartHour
    },
    on: {
      "change": _vm.setCalendarStartTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 py-0 mb-2"
  }, [_c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('label', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                                Show sunrise and sunset events on the calendar\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.localCompany.isToShowSunriseAndSunsetOnCalendar),
      callback: function($$v) {
        _vm.$set(_vm.localCompany, "isToShowSunriseAndSunsetOnCalendar", $$v)
      },
      expression: "localCompany.isToShowSunriseAndSunsetOnCalendar"
    }
  })], 1), _vm._v(" "), (_vm.localCompany.isToShowSunriseAndSunsetOnCalendar) ? _c('div', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "normal col-sm-12 fs-small info mt-2"
  }, [_vm._v("\n                                    Define the location (latitude and longitude) in order to\n                                    help us calculate the sunrise and sunset:\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column w-100"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full mt-2",
    attrs: {
      "for": "latitude"
    }
  }, [_vm._v("Latitude")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.number",
      value: (_vm.localCompany.latitude),
      expression: "localCompany.latitude",
      modifiers: {
        "trim": true,
        "number": true
      }
    }],
    staticClass: "bg-lighter col-sm-9",
    attrs: {
      "id": "latitude",
      "type": "text",
      "placeholder": "Your latitude"
    },
    domProps: {
      "value": (_vm.localCompany.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "latitude", _vm._n($event.target.value.trim()))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.geoError !== null) ? _c('span', {
    staticClass: "col-sm-12 normal fs-smaller brand mt-1"
  }, [_vm._v("\n                                        Error: " + _vm._s(_vm.geoError) + "\n                                    ")]) : _vm._e(), _vm._v(" "), (_vm.$v.localCompany.latitude.$invalid) ? _c('div', {
    staticClass: "col-sm-12 normal fs-smaller brand mt-1"
  }, [(!_vm.$v.localCompany.latitude.isLatitudeValid) ? _c('span', [_vm._v("Invalid latitude.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "full mt-2",
    attrs: {
      "for": "longitude"
    }
  }, [_vm._v("\n                                            Longitude\n                                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.number",
      value: (_vm.localCompany.longitude),
      expression: "localCompany.longitude",
      modifiers: {
        "trim": true,
        "number": true
      }
    }],
    staticClass: "bg-lighter col-sm-9",
    attrs: {
      "id": "longitude",
      "type": "text",
      "placeholder": "Your longitude"
    },
    domProps: {
      "value": (_vm.localCompany.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "longitude", _vm._n($event.target.value.trim()))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.geoError !== null) ? _c('span', {
    staticClass: "col-sm-12 normal fs-smaller brand mt-1"
  }, [_vm._v("\n                                        Error: " + _vm._s(_vm.geoError) + "\n                                    ")]) : _vm._e(), _vm._v(" "), (_vm.$v.localCompany.longitude.$invalid) ? _c('div', {
    staticClass: "col-sm-12 normal fs-smaller brand mt-1"
  }, [(!_vm.$v.localCompany.longitude.isLongitudeValid) ? _c('span', [_vm._v("Invalid longitude.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 normal fs-smaller brand mt-1"
  }, [_c('button', {
    staticClass: "btn wide mr-3 mt-2",
    on: {
      "click": function($event) {
        return _vm.getGeolocation('coordinates')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-crosshairs"
  }), _vm._v("\n                                            Pick location\n                                        ")])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "border-bottom-medium font-weight-600 darker pb-1 mb-3"
  }, [_vm._v("\n                Advanced Details\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 p-0 mb-2"
  }, [_vm._m(1), _vm._v(" "), _c('v-select', {
    staticClass: "bg-lighter",
    attrs: {
      "label": "description",
      "options": _vm.describeOffer,
      "placeholder": "Select an option"
    },
    on: {
      "input": _vm.setOfferType
    },
    model: {
      value: (_vm.selectedDescribeOffer),
      callback: function($$v) {
        _vm.selectedDescribeOffer = $$v
      },
      expression: "selectedDescribeOffer"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 p-0 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Tagline\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCompany.tagline),
      expression: "localCompany.tagline"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.localCompany.tagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localCompany, "tagline", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.localCompany.tagline.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.localCompany.tagline.minLength) ? _c('span', [_vm._v("Must have at least 4 characters.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-2 text-right"
  }, [_c('input', {
    staticClass: "btn green widest ml-auto",
    class: {
      tertiary: _vm.$v.localCompany.$invalid
    },
    attrs: {
      "type": "submit",
      "value": "Save",
      "disabled": !_vm.isDirty
    },
    on: {
      "click": _vm.save
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("\n                                Country\n                                "), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_c('span', {
    staticClass: "fs-small"
  }, [_vm._v("Choose the best option to describe your offer.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-395d97e4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/TabCompany.vue
// module id = 2208
// module chunks = 0